// RefundsPage.jsx
import React from "react";
import { Container, Row, Col, Card, Accordion, Button } from "react-bootstrap";
import Navbar from "../core/Navbar";
import Footer from "../core/Footer";

const policyText = `HIGH1 DIGITAL CONSULTING PRIVATE LIMITED believes in helping its customers as far as
possible, and has therefore a liberal cancellation policy. Under this policy:`;

const bullets = [
  `Cancellations will be considered only if the request is made immediately after placing the order.
However, the cancellation request may not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them.`,
  `HIGH1 DIGITAL CONSULTING PRIVATE LIMITED does not accept cancellation requests for
perishable items like flowers, eatables etc. However, refund/replacement can be made if the customer establishes that the quality of product delivered is not good.`,
  `In case of receipt of damaged or defective items please report the same to our Customer Service team. The request will, however, be entertained once the merchant has checked and determined the same at his own end. This should be reported within Only same day days of receipt of the products. In case you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within Only same day days of receiving the product. The Customer Service Team after looking into your complaint will take an appropriate decision.`,
  `In case of complaints regarding products that come with a warranty from manufacturers, please refer the issue to them. In case of any Refunds approved by the HIGH1 DIGITAL CONSULTING PRIVATE LIMITED, it’ll take 3-5 Days for the refund to be processed to the end customer.`,
];

const RefundsPage = () => {
  return (
    <>
      <Navbar />

      <main>
        <header className="bg-light py-5">
          <Container>
            <Row className="justify-content-center">
              <Col
                xs={12}
                md={10}
                lg={8}
                className="text-center"
              >
                <h1 className="display-6 fw-bold">
                  Refund & Cancellation Policy
                </h1>
                <p className="text-muted mt-2">
                  We try to keep things simple and help our customers — read the
                  policy below for details.
                </p>
              </Col>
            </Row>
          </Container>
        </header>

        <section className="py-5">
          <Container>
            <Row className="justify-content-center">
              <Col
                xs={12}
                md={10}
                lg={8}
              >
                <Card className="shadow-sm mb-4">
                  <Card.Body>
                    <Card.Title
                      as="h2"
                      className="h5"
                    >
                      Policy Summary
                    </Card.Title>

                    <Card.Text
                      className="mt-3"
                      style={{ whiteSpace: "pre-line" }}
                    >
                      {policyText}
                    </Card.Text>

                    <ul className="mt-3">
                      {bullets.map((b, i) => (
                        <li
                          key={i}
                          className="mb-2"
                          style={{ lineHeight: 1.6 }}
                        >
                          {b}
                        </li>
                      ))}
                    </ul>
                  </Card.Body>
                </Card>

                <Accordion
                  defaultActiveKey="0"
                  className="mb-4"
                >
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      How to Request a Cancellation / Refund
                    </Accordion.Header>
                    <Accordion.Body>
                      <ol>
                        <li>
                          Contact our Customer Service immediately after placing
                          the order if you wish to cancel.
                        </li>
                        <li>
                          If the merchant/vendor has already been notified and
                          shipping started, cancellation may not be possible.
                        </li>
                        <li>
                          For damaged/defective items, report the issue to
                          Customer Service on the same day of receipt (as per
                          policy text above).
                        </li>
                        <li>
                          Keep photos, order number and any supporting details
                          handy to speed up resolution.
                        </li>
                      </ol>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="1">
                    <Accordion.Header>Refund Timeline</Accordion.Header>
                    <Accordion.Body>
                      If a refund is approved by HIGH1 DIGITAL CONSULTING
                      PRIVATE LIMITED, it’ll take <strong>3–5 days</strong> for
                      the refund to be processed to the end customer (depending
                      on the payment method and bank / card processing times).
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      Warranty & Manufacturer Returns
                    </Accordion.Header>
                    <Accordion.Body>
                      There is no physical warranty Service delivery is based on
                      SLA (Service-Level Agreement) Portal access is
                      subscription-based, not refundable after activation Any
                      downtime is handled via tech-support resolution, not
                      refunds
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                <Card className="shadow-sm">
                  <Card.Body className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between">
                    <div>
                      <Card.Title
                        as="h3"
                        className="h6 mb-2"
                      >
                        Still need help?
                      </Card.Title>
                      <Card.Text className="mb-0 text-muted">
                        Reach out to our Customer Service team with your order
                        number and details. We'll review and respond as quickly
                        as possible.
                      </Card.Text>
                    </div>

                    <div className="mt-3 mt-md-0">
                      <Button
                        style={{ background: "red", border: "none" }}
                        href="mailto:sales@high1digital.com"
                        className="me-2 mb-2"
                        aria-label="Email customer service"
                      >
                        Email Customer Service
                      </Button>

                      <Button
                        style={{
                          background: "transparent",
                          border: "1px solid red",
                          color: "red",
                        }}
                        href="tel:+6284735052"
                        aria-label="Call customer service"
                      >
                        Call Customer Service
                      </Button>
                    </div>
                  </Card.Body>
                </Card>

                <p className="text-muted small mt-3">
                  Note: This page preserves the official policy wording. For
                  edge cases or urgent issues, please contact Customer Service
                  directly.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default RefundsPage;
